exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".is-talking[data-v-71520e78]{border-color:#b01202}", ""]);
